;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import ListItemButton from "@mui/material/ListItemButton"
import DialogTitle from "@mui/material/DialogTitle"
import Dialog from "@mui/material/Dialog"
import { FaFacebook, FaEnvelope, FaLink } from "react-icons/fa"
import { RiTwitterXFill } from "react-icons/ri" // Import the Twitter icon from Remix Icons
import updateSuccessMessage from "../../../graphql/mutations/snackbarMessage/updateSuccessMessage"

function SharePageDialog({ onClose, open, url, title }) {
  const handleClose = () => {
    onClose()
  }

  const shareOptions = [
    {
      name: "on X (Twitter)",
      icon: <RiTwitterXFill size={24} />,
      link: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
      target: "_blank",
    },
    {
      name: "on Facebook",
      icon: <FaFacebook size={24} />,
      link: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        url,
      )}`,
      target: "_blank",
    },
    {
      name: "on Email",
      icon: <FaEnvelope size={24} />,
      link: `mailto:?subject=Check out this group!&body=I found this group interesting for you: ${url}`,
      target: "_blank",
    },
    {
      name: "Copy Link",
      icon: <FaLink size={24} />,
      onClick: () => {
        navigator.clipboard.writeText(url).then(() => {
          updateSuccessMessage("Link copied to clipboard!")
          handleClose()
        })
      },
      // No link or target needed for Copy Link option
    },
  ]

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <List sx={{ pt: 0 }}>
        {shareOptions.map((option, index) => (
          <ListItem key={index}>
            <ListItemButton
              href={option.link}
              target={option.target || undefined}
              rel={option.target ? "noopener noreferrer" : undefined}
              onClick={option.onClick}
            >
              <ListItemIcon>{option.icon}</ListItemIcon>
              <ListItemText>{option.name}</ListItemText>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Dialog>
  )
}

export default SharePageDialog
